
export default function ProductExamplesSection() {
  const productCategories = [
    {
      category: '美容・コスメ',
      icon: 'ri-heart-line',
      description: '化粧品、スキンケア、ヘアケア商品など',
      examples: [
        {
          name: 'プレミアム美容液',
          brand: 'Beauty Lab',
          price: '¥8,800',
          reward: '¥1,250',
          image: 'https://public.readdy.ai/ai/img_res/998a815fa191b88f3c26a748ca1802fd.jpg',
          features: ['ヒアルロン酸配合', 'エイジングケア', '無添加処方']
        },
        {
          name: 'オーガニックシャンプー',
          brand: 'Natural Care',
          price: '¥3,200',
          reward: '¥600',
          image: 'https://readdy.ai/api/search-image?query=Organic%20shampoo%20bottle%20with%20natural%20ingredients%2C%20eco-friendly%20packaging%2C%20botanical%20elements%2C%20clean%20product%20photography%2C%20sustainable%20beauty%20product&width=300&height=300&seq=beauty2&orientation=squarish',
          features: ['植物由来成分', 'ノンシリコン', '環境配慮']
        }
      ]
    },
    {
      category: '健康・サプリメント',
      icon: 'ri-heart-pulse-line',
      description: 'サプリメント、健康食品、フィットネス用品など',
      examples: [
        {
          name: 'マルチビタミン',
          brand: 'Health Plus',
          price: '¥4,500',
          reward: '¥900',
          image: 'https://readdy.ai/api/search-image?query=Premium%20multivitamin%20supplement%20bottle%20with%20colorful%20capsules%2C%20health%20and%20wellness%20product%20photography%2C%20clean%20medical%20background%2C%20professional%20pharmaceutical%20presentation&width=300&height=300&seq=health1&orientation=squarish',
          features: ['30日分', '12種類のビタミン', '国内製造']
        },
        {
          name: 'プロテインパウダー',
          brand: 'Fit Life',
          price: '¥6,800',
          reward: '¥1,100',
          image: 'https://readdy.ai/api/search-image?query=Protein%20powder%20container%20with%20fitness%20theme%2C%20sports%20nutrition%20product%2C%20gym%20equipment%20background%2C%20athletic%20lifestyle%20photography%2C%20muscle%20building%20supplement&width=300&height=300&seq=health2&orientation=squarish',
          features: ['ホエイプロテイン', '高タンパク質', 'バニラ味']
        }
      ]
    },
    {
      category: '食品・飲料',
      icon: 'ri-restaurant-line',
      description: '健康食品、お茶、調味料、お菓子など',
      examples: [
        {
          name: 'オーガニック緑茶',
          brand: 'Tea Garden',
          price: '¥2,800',
          reward: '¥500',
          image: 'https://readdy.ai/api/search-image?query=Premium%20organic%20green%20tea%20package%20with%20traditional%20Japanese%20design%2C%20elegant%20tea%20packaging%2C%20natural%20tea%20leaves%2C%20authentic%20Japanese%20tea%20ceremony%20aesthetic&width=300&height=300&seq=food1&orientation=squarish',
          features: ['有機栽培', '静岡県産', '深蒸し茶']
        },
        {
          name: 'グルテンフリークッキー',
          brand: 'Healthy Snack',
          price: '¥1,800',
          reward: '¥400',
          image: 'https://readdy.ai/api/search-image?query=Gluten-free%20cookies%20in%20attractive%20packaging%2C%20healthy%20snack%20food%20photography%2C%20wholesome%20ingredients%20visible%2C%20natural%20organic%20food%20presentation&width=300&height=300&seq=food2&orientation=squarish',
          features: ['小麦不使用', 'アーモンド粉使用', '低糖質']
        }
      ]
    },
    {
      category: '家電・電子機器',
      icon: 'ri-smartphone-line',
      description: 'スマートフォンアクセサリー、家電製品など',
      examples: [
        {
          name: 'ワイヤレス充電器',
          brand: 'Tech Pro',
          price: '¥5,500',
          reward: '¥1,000',
          image: 'https://readdy.ai/api/search-image?query=Modern%20wireless%20charging%20pad%20with%20smartphone%2C%20sleek%20technology%20product%20photography%2C%20minimalist%20design%2C%20contemporary%20electronics%20on%20clean%20desk%20setup&width=300&height=300&seq=tech1&orientation=squarish',
          features: ['急速充電対応', 'Qi規格', 'LED表示']
        },
        {
          name: 'Bluetoothイヤホン',
          brand: 'Sound Wave',
          price: '¥8,900',
          reward: '¥1,400',
          image: 'https://readdy.ai/api/search-image?query=Premium%20bluetooth%20earbuds%20with%20charging%20case%2C%20high-end%20audio%20equipment%20photography%2C%20modern%20wireless%20technology%2C%20sleek%20black%20design%20on%20white%20background&width=300&height=300&seq=tech2&orientation=squarish',
          features: ['ノイズキャンセリング', '防水仕様', '長時間再生']
        }
      ]
    },
    {
      category: '生活用品・雑貨',
      icon: 'ri-home-line',
      description: '日用品、インテリア、キッチン用品など',
      examples: [
        {
          name: 'エコ洗剤セット',
          brand: 'Clean Life',
          price: '¥3,600',
          reward: '¥700',
          image: 'https://readdy.ai/api/search-image?query=Eco-friendly%20cleaning%20products%20set%20with%20natural%20ingredients%2C%20sustainable%20household%20items%2C%20green%20living%20products%2C%20environmentally%20conscious%20cleaning%20supplies&width=300&height=300&seq=home1&orientation=squarish',
          features: ['植物由来', '生分解性', '詰替え用付き']
        },
        {
          name: 'アロマディフューザー',
          brand: 'Relax Home',
          price: '¥7,200',
          reward: '¥1,200',
          image: 'https://readdy.ai/api/search-image?query=Modern%20aroma%20diffuser%20with%20essential%20oils%2C%20relaxing%20home%20atmosphere%2C%20wellness%20lifestyle%20product%2C%20peaceful%20interior%20design%20element&width=300&height=300&seq=home2&orientation=squarish',
          features: ['超音波式', 'タイマー機能', 'LED照明']
        }
      ]
    },
    {
      category: 'ファッション・アクセサリー',
      icon: 'ri-shirt-line',
      description: 'アクセサリー、バッグ、時計など',
      examples: [
        {
          name: 'レザーハンドバッグ',
          brand: 'Style Collection',
          price: '¥12,800',
          reward: '¥1,750',
          image: 'https://readdy.ai/api/search-image?query=Elegant%20leather%20handbag%20with%20sophisticated%20design%2C%20luxury%20fashion%20accessory%20photography%2C%20premium%20materials%2C%20stylish%20womens%20bag%20on%20clean%20background&width=300&height=300&seq=fashion1&orientation=squarish',
          features: ['本革使用', '多機能ポケット', '日本製']
        },
        {
          name: 'スマートウォッチ',
          brand: 'Time Tech',
          price: '¥15,900',
          reward: '¥2,100',
          image: 'https://readdy.ai/api/search-image?query=Modern%20smartwatch%20with%20fitness%20tracking%20features%2C%20wearable%20technology%20product%20photography%2C%20sleek%20design%2C%20health%20monitoring%20device&width=300&height=300&seq=fashion2&orientation=squarish',
          features: ['健康管理機能', '防水設計', 'GPS搭載']
        }
      ]
    }
  ];

  const scrollToApplication = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSeBEM-6ePnkcR5Twm0MHglWW_H3zatlKCf08MmRm5c-xbRyYw/viewform?embedded=true', '_blank');
  };

  return (
    <section id="product-examples" className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            過去のモニター募集商品例
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            様々なジャンルの商品をご用意しています。あなたの興味に合った商品を見つけてください
          </p>
        </div>

        <div className="space-y-12 sm:space-y-16">
          {productCategories.map((category, categoryIndex) => (
            <div key={categoryIndex} className="bg-gray-50 rounded-2xl p-4 sm:p-8">
              <div className="flex items-center mb-6 sm:mb-8">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                  <i className={`${category.icon} text-xl sm:text-2xl text-blue-600`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900">{category.category}</h3>
                  <p className="text-sm sm:text-base text-gray-600">{category.description}</p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
                {category.examples.map((product, productIndex) => (
                  <div key={productIndex} className="bg-white rounded-xl shadow-lg p-4 sm:p-6 hover:shadow-xl transition-shadow duration-300">
                    <div className="flex flex-col sm:flex-row items-start space-y-4 sm:space-y-0 sm:space-x-4">
                      <img 
                        src={product.image} 
                        alt={product.name}
                        className="w-full sm:w-24 h-48 sm:h-24 object-cover rounded-lg flex-shrink-0"
                      />
                      <div className="flex-1 min-w-0">
                        <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-1">
                          {product.name}
                        </h4>
                        <p className="text-sm text-gray-600 mb-2">{product.brand}</p>
                        <div className="flex items-center justify-between mb-3">
                          <span className="text-base sm:text-lg font-bold text-gray-900">{product.price}</span>
                          <span className="bg-green-100 text-green-800 px-2 sm:px-3 py-1 rounded-full text-xs sm:text-sm font-semibold">
                            謝礼 {product.reward}
                          </span>
                        </div>
                        <div className="flex flex-wrap gap-1">
                          {product.features.map((feature, featureIndex) => (
                            <span key={featureIndex} className="bg-blue-50 text-blue-700 px-2 py-1 rounded text-xs">
                              {feature}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 bg-blue-50 rounded-2xl p-4 sm:p-8 text-center">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
            新商品が続々追加中！
          </h3>
          <p className="text-sm sm:text-base text-gray-600 mb-6">
            毎週新しい商品が追加されています。登録後、あなたの興味に合った商品をお知らせします。<br/>
            <strong>商品はモニター終了後、無料でお持ちいただけます！</strong>
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 text-center mb-6 sm:mb-8">
            <div className="bg-white rounded-lg p-3 sm:p-4">
              <div className="text-xl sm:text-2xl font-bold text-blue-600 mb-1">150+</div>
              <div className="text-xs sm:text-sm text-gray-600">取扱商品数</div>
            </div>
            <div className="bg-white rounded-lg p-3 sm:p-4">
              <div className="text-xl sm:text-2xl font-bold text-blue-600 mb-1">50+</div>
              <div className="text-xs sm:text-sm text-gray-600">提携ブランド</div>
            </div>
            <div className="bg-white rounded-lg p-3 sm:p-4">
              <div className="text-xl sm:text-2xl font-bold text-blue-600 mb-1">毎週</div>
              <div className="text-xs sm:text-sm text-gray-600">新商品追加</div>
            </div>
            <div className="bg-white rounded-lg p-3 sm:p-4">
              <div className="text-xl sm:text-2xl font-bold text-blue-600 mb-1">6</div>
              <div className="text-xs sm:text-sm text-gray-600">主要カテゴリー</div>
            </div>
          </div>
          
          {/* 中腹CTA（信頼/特典の直後） */}
          <button 
            onClick={scrollToApplication}
            className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-bold px-6 sm:px-8 py-3 sm:py-4 rounded-lg cursor-pointer transition-colors whitespace-nowrap text-base sm:text-lg"
          >
            <i className="ri-gift-line mr-2"></i>
            商品モニター会員応募
          </button>
        </div>
      </div>
    </section>
  );
}
